export default __webpack_public_path__ + "static/media/PF_03.e03c022f.png";